import { useChangeUrlTool } from './changeUrl';
import { useGetNavigationTargetDetailsTool } from './getNavigationTargetDetails';
import { useHighlightElementTool } from './highlightElement';
import { useInspectCurrentPageTool } from './inspectCurrentPage';

/**
 * Registers cross-page copilot frontend tools available on every Alvie screen.
 *
 * Composes inspect, highlight, allowlisted navigation, and silent navigation
 * detail tools that work on any page once CopilotContext has registered page
 * elements and context.
 */
export const useCopilotGlobalPageTools = () => {
  useInspectCurrentPageTool();
  useHighlightElementTool();
  useGetNavigationTargetDetailsTool();
  useChangeUrlTool();
};